<template>
  <div class="wt2-sg wt2-dashboard">
    <div class="wt2-dashboard-main-panel">
      <component
        :is="mainPanel"
        @filterschange="triggerAnalyticsFiltersEvent"
      />
    </div>
  </div>
</template>

<script>
import app from 'app';
import Analytics from 'c/WtAnalytics';
import DashboardHome from 'v/Dashboard/DashboardHome.vue';
import DashboardInProgress from 'v/Dashboard/DashboardInProgress.vue';
import DashboardStoryVersions from 'v/Dashboard/DashboardStoryVersions.vue';
import DashboardProduced from 'v/Dashboard/DashboardProduced.vue';
import DashboardDiscover from 'v/Dashboard/DashboardDiscover.vue';
import DashboardWochitStoryboards from 'v/Dashboard/DashboardWochitStoryboards.vue';
import DashboardMyStoryboards from 'v/Dashboard/DashboardMyStoryboards.vue';
import DashboardAnalytics from 'v/Dashboard/DashboardAnalytics.vue';
import { mapGetters, mapMutations, mapState } from 'vuex';

export default app.Vue.extend({
  name: 'Dashboard',
  components: {
    DashboardHome,
    DashboardInProgress,
    DashboardStoryVersions,
    DashboardProduced,
    DashboardDiscover,
    DashboardWochitStoryboards,
    DashboardMyStoryboards,
    DashboardAnalytics,
  },

  computed: {
    ...mapGetters(['selectedStory']),
    ...mapState({
      filters: (state) => state.dashboard.storyboardsFilters,
    }),

    routePath() {
      return this.$store.getters.routePath;
    },

    mainPanel() {
      let path = this.routePath || '';
      if (path.endsWith('/')) {
        path = path.substring(0, path.length - 1);
      }
      // Full-page version history, e.g. dashboard/versions/{storyId}
      if (path.startsWith('dashboard/versions/')) {
        return 'DashboardStoryVersions';
      }
      const routes = {
        'dashboard/home': 'DashboardHome',
        'dashboard/inProgress': 'DashboardInProgress',
        'dashboard/myVideos': 'DashboardProduced',
        'dashboard/discover': 'DashboardDiscover',
        'dashboard/storyboards': 'DashboardWochitStoryboards',
        'dashboard/my-storyboards': 'DashboardMyStoryboards',
        'dashboard/analytics': 'DashboardAnalytics',
      };
      return routes[path];
    },
  },

  beforeDestroy() {
    document.body.removeEventListener('click', this.resetSelectedStory);
  },

  mounted() {
    if (this.categoryId) {
      this.filters.categoryIds = [this.categoryId];
    }

    app.delayedSpinner.hide({ delay: 0 });

    document.body.addEventListener('click', this.resetSelectedStory);
  },

  methods: {
    ...mapMutations(['setSelectedStory']),

    resetSelectedStory(e) {
      if (!this.selectedStory) {
        return;
      }
      const closest = e.target.closest(`[data-id="${this.selectedStory}"]`);
      if (closest) {
        return;
      }
      this.setSelectedStory(null);
    },

    $_persistDataModel(key, value) {
      app.stash.set(key, _.cloneDeep(value));
    },

    triggerAnalyticsFiltersEvent(options) {
      options = Object.assign(
        {
          filter: '',
        },
        options
      );

      Analytics.trigger('analytics:dashboard:filters', {
        tab: _.startCase(this.mainPanel),
        filter: options.filter,
      });
    },
  },
});
</script>
